export default __webpack_public_path__ + "static/media/prep_2.43f4edbf.svg";